import React from 'react';
import get from 'lodash/get';
import GenericTitle from './generic-title';
import ListHeaderTitleh5 from '../../atoms/list-header-title-h5';

const VideoTitle = props => (
  //   <GenericTitle
  //     title={` ${get(props, 'title', 'VIDEOS')}`}
  //     href={`/videos?src=story-page`}
  //     iconCode="icon-ic_videos"
  // />
  <ListHeaderTitleh5
    title={` ${get(props, 'title', 'VIDEOS')}`}
    iconCode="icon-ic_videos">
  </ListHeaderTitleh5>
);

export default VideoTitle;
